export default {"src":"/_next/static/media/avatar_icon.709eeaa8.svg","height":82,"width":82};